import type { LucideIcon } from 'lucide-react'
import {
  BookOpen,
  ClipboardCheck,
  Dumbbell,
  Library,
  RotateCcw,
  Sparkles,
} from 'lucide-react'
import { useLandingCopy } from '@/hooks/useGuestLocale'
import { landingCapabilityCardClass } from '@/components/landing/landingStyles'
import { cn } from '@/components/ui/cn'

const CAPABILITY_ICONS: LucideIcon[] = [
  BookOpen,
  Library,
  RotateCcw,
  Sparkles,
  Dumbbell,
  ClipboardCheck,
]

const CAPABILITY_ICON_STYLES = [
  'bg-amber-500/12 text-amber-700',
  'bg-violet-500/12 text-violet-700',
  'bg-sky-500/12 text-sky-700',
  'bg-emerald-500/12 text-emerald-700',
  'bg-orange-500/12 text-orange-700',
  'bg-rose-500/12 text-rose-700',
]

export function LandingCapabilitiesSection() {
  const copy = useLandingCopy()

  return (
    <section data-testid="landing-capabilities">
      <div className="text-center lg:mx-auto lg:max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary/80">
          Lexio
        </p>
        <h2 className="mt-2 text-balance text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
          {copy.capabilitiesTitle}
        </h2>
        <p className="mt-3 text-pretty text-sm leading-relaxed text-muted-foreground sm:text-base">
          {copy.capabilitiesSubtitle}
        </p>
      </div>

      <div
        className="mt-8 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3"
        data-testid="landing-capabilities-grid"
      >
        {copy.capabilities.map((capability, index) => {
          const Icon = CAPABILITY_ICONS[index]

          return (
            <article key={capability.title} className={landingCapabilityCardClass}>
              <div
                className={cn(
                  'flex h-9 w-9 items-center justify-center rounded-lg',
                  CAPABILITY_ICON_STYLES[index],
                )}
              >
                <Icon className="h-4 w-4" aria-hidden />
              </div>
              <h3 className="mt-3 text-sm font-semibold leading-snug text-foreground sm:text-base">
                {capability.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
                {capability.body}
              </p>
            </article>
          )
        })}
      </div>
    </section>
  )
}
